/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * User-provided cancellation reasons (why they chose to cancel)
 */
export type CancellationReason = typeof CancellationReason[keyof typeof CancellationReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationReason = {
  TOO_EXPENSIVE: 'TOO_EXPENSIVE',
  NOT_USEFUL: 'NOT_USEFUL',
  JUST_TESTING: 'JUST_TESTING',
  TECHNICAL_ISSUES: 'TECHNICAL_ISSUES',
  CONCERNED_ABOUT_RESULTS: 'CONCERNED_ABOUT_RESULTS',
  OTHER: 'OTHER',
} as const;
